import Icon from 'veui/components/Icon'
import { IconArrowLeft } from 'dls-icons-vue'

Icon.register('arrow-left', IconArrowLeft)
